// src/components/AhaMomentAIHero.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth } from 'firebase/auth';
import { v4 as uuidv4 } from 'uuid';
import { trackEvent } from '../utils/analytics/trackEvent';
import { askAhaMomentAI } from '../api/askAhaMomentAI';

const AhaMomentAIHero = () => {
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const auth = getAuth();

  const suggestions = [
    'Help me learn basics of technical analysis?',
    'Teach me how to interpret signals?',
    'Help me choose a broker?',
    'Help me understand basics of fundamental analysis?',
  ];

  const handleAskAI = async () => {
    if (!input.trim()) return;

    setLoading(true);

    const chatSessionId = uuidv4();
    const userId = auth.currentUser?.uid || 'anonymous';
    const usermessage = input.trim();

    trackEvent('aha_homepage_ask_ai_clicked', {
      screen: 'AhaMomentAIHero',
      user_id: userId,
      chatsessionid: chatSessionId,
      message_length: usermessage.length,
      channel: 'web',
      page_path: window.location.pathname,
      source: 'homepage_hero',
      timestamp: Date.now(),
    });

    // Immediate navigation
    navigate(`/learn/space/${chatSessionId}`, {
      state: { question: usermessage },
    });

    // Background AI fetch
    askAhaMomentAI({
      userId,
      chatsessionid: chatSessionId,
      usermessage,
      messageCount: 0,
    }).then((airesponse) => {
      sessionStorage.setItem(`ahaResponse-${chatSessionId}`, JSON.stringify({
        question: usermessage,
        airesponse,
      }));
    }).catch((err) => {
      console.warn('AI fetch failed:', err);
    });

    setLoading(false);
  };

  return (
    <section style={{ backgroundColor: '#232830', padding: '60px 20px 40px', color: '#fff' }}>
      <div style={{ maxWidth: '760px', margin: '0 auto', textAlign: 'center', color: '#ffffff' }}>
        <h1 style={{ fontSize: '2rem', fontWeight: '800', marginBottom: '0.5rem', color: '#ffffff'}}>
          📈 Learn faster. Trade smarter. Invest confidently.
        </h1>
        <p style={{ fontSize: '1.1rem', marginBottom: '1.5rem', color: '#ddd' }}>
          Confused about trading or investing concepts? Just ask.
        </p>

        <div style={{ position: 'relative', marginBottom: '1rem' }}>
          <textarea
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="e.g. Why did BTC reverse from $72k?"
            rows={3}
            style={{
              width: '100%',
              padding: '1rem',
              borderRadius: '16px',
              fontSize: '1rem',
              border: '1px solid #ccc',
              outline: 'none',
              resize: 'vertical',
              fontFamily: 'Nunito Sans, sans-serif',
              color: '#fff',
              backgroundColor: '#2C2F36',
            }}
          />
          <button
            onClick={handleAskAI}
            style={{
              position: 'absolute',
              bottom: '10px',
              right: '10px',
              padding: '0.6rem 1.1rem',
              backgroundColor: '#FF7C24',
              color: '#fff',
              fontWeight: '700',
              fontSize: '1rem',
              border: 'none',
              borderRadius: '10px',
              cursor: 'pointer',
            }}
          >
            {loading ? 'Thinking...' : 'Ask AI'}
          </button>
        </div>

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.8rem', justifyContent: 'center' }}>
          {suggestions.map((text, idx) => (
            <button
              key={idx}
              onClick={() => {
                setInput(text);
                trackEvent('aha_homepage_suggestion_clicked', {
                  screen: 'AhaMomentAIHero',
                  topic: text,
                  user_id: auth.currentUser?.uid || 'anonymous',
                  channel: 'web',
                  page_path: window.location.pathname,
                  source: 'homepage_hero',
                  timestamp: Date.now(),
                });
              }}
              style={{
                padding: '0.5rem 0.9rem',
                borderRadius: '12px',
                fontWeight: '600',
                fontSize: '0.95rem',
                backgroundColor: '#fff',
                color: '#232830',
                border: 'none',
                fontFamily: 'Nunito Sans, sans-serif',
                cursor: 'pointer',
              }}
            >
              {text}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AhaMomentAIHero;
